'use strict';

require('base/Underscore.Setup');
require('base/Colido.View');
require('base/Marionette.Setup');
require('base/Messenger.Setup');

var Backbone = require('backbone');
var GlobalModule = require('modules/global/module');
var Application = require('base/Colido.Application');
var AppLayout = require('modules/share/views/layout/main');
var AppRouter = require('modules/share/app/router');
var loadModules = require('./modules/index-shared');
var Util = require('base/Colido.Util');

var App = new Application({appType: 'share'});

window.App = App;

App.Behaviors = {};

// Start Global module
App.module('Global', GlobalModule);

App.addInitializer(function(){
    this.router = new AppRouter();
    // this.user = new UserModel();

    // var language = this.user.getLanguage();
    $(document).ajaxSuccess(function(event, request, settings) {
        this.setLanguage(request.getResponseHeader('Content-Language'));
    }.bind(this));

    this.setLanguage(Util.getPreferredLanguage(['en', 'de']));

    this.rootView = new AppLayout();
});

// Starts the app
App.on('start', function(options) {
    $.ajax(App.getApiUrl('core/currencies')).done(function(){
        Backbone.history.start({pushState: true, root: App.config.basePath});
    });
});

loadModules(App);